import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { canonicalFor, isPrivatePath, setCanonical, setMeta, setRobots } from "./seo";

// Set once inside the router: every address gets its canonical form, and private pages are kept out of the search results.
export default function RouteSeo() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const canonical = canonicalFor(pathname, search);
    setCanonical(canonical);
    setMeta("og:url", canonical, "property");
    setRobots(isPrivatePath(pathname) ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
  }, [pathname, search]);
  return null;
}
